import React from 'react';
import HomeHero1 from '../../components/User/Home/HomeHero1';
import OurIdentity from '../../components/User/Home/OurIdentity';
import FeaturesShowcaseSection from '../../components/User/Home/FeaturesShowcaseSection';
import WeServe from '../../components/User/Home/WeServe';
import Expertise from '../../components/User/Home/Expertise';
import ItApproch from '../../components/User/Home/ItApproch';
import CaseStudies from '../../components/User/Home/CaseStudies';
import Testimonial from '../../components/User/Home/Testimonial';
import StrategiesPage from '../../components/User/Home/StrategiesPag';

const Home = () => (
    <div>
        <HomeHero1/>
        <OurIdentity/>
        <FeaturesShowcaseSection/>
        <WeServe/>
        <Expertise/>
        <ItApproch/>
        <CaseStudies/>
        <Testimonial/>
        <StrategiesPage/>
    </div>
);

export default Home;
